import { render, staticRenderFns } from "./SysUser.vue?vue&type=template&id=13450660&scoped=true"
import script from "./SysUser.vue?vue&type=script&lang=js"
export * from "./SysUser.vue?vue&type=script&lang=js"
import style0 from "./SysUser.vue?vue&type=style&index=0&id=13450660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13450660",
  null
  
)

export default component.exports